import React, { useState, useEffect } from "react";
import { fetchLogo } from "../../../services/apiService";

function Logo() {
    const [logo, setLogo] = useState([]);
    useEffect(() => {
        fetchLogo()
            .then((data) => setLogo(data[0]?.logo || data?.logo || ''))
            .catch((error) => console.error("Error fetching logo:", error));
    }, []);

  return (
    <div className="logo" tabIndex="0" style={{ backgroundImage: `url('${process.env.REACT_APP_API_URL}/storage/${logo}')` }}></div>
  );
}
export default Logo;